import type { Appearance } from "@stripe/stripe-js";
import { loadStripe } from "@stripe/stripe-js/pure";
import { useMemo } from "react";

import { useStripePublishableKey } from "@/queries/organization-queries";
import { getCSSValue } from "@/utils/css";

export const getStripeAppearance = (): Appearance => {
    const appearance = {
        variables: {
            colorBackground: `rgb(${getCSSValue("--surface-primary")})`,
            colorText: `rgb(${getCSSValue("--content-primary")})`,
            colorPrimary: `rgb(${getCSSValue("--content-primary")})`,
            colorPrimaryText: `rgb(${getCSSValue("--content-secondary")})`,
        },
    };
    return appearance;
};

export const useStripePromise = () => {
    const { data: stripeKey, isLoading } = useStripePublishableKey();

    // loadStripe from @stripe/stripe-js/pure is idempotent: it injects the
    // Stripe.js <script> once and reuses the existing tag on later calls.
    const stripePromise = useMemo(() => (stripeKey ? loadStripe(stripeKey) : undefined), [stripeKey]);

    return {
        stripePromise,
        isLoading,
    };
};
